import React from "react";
import _ from "lodash";
import {
  Dialog,
  DialogContent,
  Slide,
  Button,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from "@mui/material";

import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

import Icon_doanh_nghiep from "../../assets/icon_doanh_nghiep.svg";
import Icon_userTF from "../../assets/Icon_userTF.svg";
import Icon_mstTF from "../../assets/Icon_mstTF.svg";
import icon_locationTF from "../../assets/icon_locationTF.svg";
import TextField from "../overightMui/TextField";
import { useEffect } from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function Dialog_Bill({ state, dispatch }) {
  const { dialogBill, errors, currentStep, insuranceInfo } = state;
  const classes = useStyles();

  useEffect(() => {
    dispatch("validatePage");
  }, [dialogBill.name, dialogBill.taxCode, dialogBill.address])

  return (
    <Dialog
      open={!!dialogBill.open}
      TransitionComponent={Transition}
      className={classes.container}
      onClose={() => dispatch("closeDialogBill")}
      PaperProps={{
        className: classes.paperProps, // Áp dụng class cho Paper của Dialog
      }}
    >
      <DialogContent className={classes.content}>
        <div className={classes.title}>
          <div className="text">Thông tin hoá đơn</div>
          <IconButton onClick={() => dispatch("closeDialogBill")}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <div className={classes.form}>
          <div>
            <div style={{}}>
              Lựa chọn hoá đơn <span style={{ color: "red" }}>*</span>
            </div>
            <FormControl fullWidth>
              <RadioGroup
                row
                name="row-radio-buttons-group"
                sx={{ padding: "0 8px" }}
                value={dialogBill.type}
                onChange={(e) =>
                  dispatch({
                    type: "onChangeBill",
                    name: "type",
                    value: e.target.value,
                  })
                }
              >
                <FormControlLabel
                  value="PERSONAL"
                  sx={{
                    "& .Mui-checked": { color: "#009B4B !important" },
                    marginRight: "36px",
                  }}
                  control={<Radio size="small" />}
                  label="Cá nhân"
                />
                <FormControlLabel
                  value="BUSINESS"
                  sx={{
                    "& .MuiRadio-root.Mui-checked": {
                      color: "#009B4B !important",
                    },
                  }}
                  control={<Radio size="small" />}
                  label="Doanh nghiệp"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div style={{ margin: "12px 0" }} key={`infor_user`}>
            <div style={{ marginBottom: "6px" }}>
              {dialogBill.type === "BUSINESS"
                ? "Tên doanh nghiệp"
                : "Họ và tên chủ xe"}{" "}
              <span style={{ color: "red" }}> *</span>
            </div>
            <TextField
              fullWidth
              error={errors[`step${currentStep}`]?.includes("name_bill")}
              helperText={
                errors[`step${currentStep}`]?.includes("name_bill") ? "Vui lòng nhập thông tin" : false
              }
              placeholder={
                dialogBill.type === "BUSINESS"
                  ? "Nhập tên doanh nghiệp"
                  : "Nhập họ và tên"
              }
              sx={{
                background: "white",
                borderRadius: "8px",
                "& .MuiInputBase-root": {
                  background: "white",
                  borderRadius: "8px",
                  paddingLeft: "10px",

                  "& input": { paddingLeft: "0px" },
                },
              }}
              value={dialogBill?.name || ""}
              onChange={(e) => {
                dispatch({
                  type: "onChangeBill",
                  name: "name",
                  value: e.target.value,
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={
                        dialogBill.type === "BUSINESS"
                          ? Icon_doanh_nghiep
                          : Icon_userTF
                      }
                    />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div style={{ margin: "12px 0" }} key={`infor_user`}>
            <div style={{ marginBottom: "6px" }}>
              Mã số thuế <span style={{ color: "red" }}> * </span>
            </div>
            <TextField
              fullWidth
              error={errors[`step${currentStep}`]?.includes("taxCode_bill") || errors[`step${currentStep}`]?.includes("vat_format")}
              helperText={
                errors[`step${currentStep}`]?.includes("taxCode_bill")
                  ? "Vui lòng nhập thông tin!"
                  : errors[`step${currentStep}`]?.includes("vat_format")
                    ? "Vui lòng nhập đúng định dạng mã số thuế!"
                    : false
              }
              placeholder="Nhập mã số thuế"
              sx={{
                background: "white",
                borderRadius: "8px",
                "& .MuiInputBase-root": {
                  background: "white",
                  borderRadius: "8px",
                  paddingLeft: "10px",

                  "& input": { paddingLeft: "0px" },
                },
              }}
              value={dialogBill?.taxCode || ""}
              onChange={(e) => {
                dispatch({
                  type: "onChangeBill",
                  name: "taxCode",
                  value: e.target.value,
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={Icon_mstTF} />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div style={{ margin: "12px 0" }} key={`infor_user`}>
            <div style={{ marginBottom: "6px" }}>
              Địa chỉ <span style={{ color: "red" }}> * </span>
            </div>
            <TextField
              fullWidth
              error={errors[`step${currentStep}`]?.includes("address_bill")}
              helperText={
                errors[`step${currentStep}`]?.includes("address_bill")
                  ? "Vui lòng nhập thông tin!"
                  : false
              }
              placeholder="Nhập địa chỉ"
              sx={{
                background: "white",
                borderRadius: "8px",
                "& .MuiInputBase-root": {
                  background: "white",
                  borderRadius: "8px",
                  paddingLeft: "10px",

                  "& input": { paddingLeft: "0px" },
                },
              }}
              value={dialogBill?.address || ""}
              onChange={(e) => {
                dispatch({
                  type: "onChangeBill",
                  name: "address",
                  value: e.target.value,
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={icon_locationTF} />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className={classes.box_button}>
            <Button
              sx={{
                textTransform: "none",
                color: "white",
                background: "#009B4B",
                width: "100%",
                fontWeight: "600",
                borderRadius: "6px",
                "&:hover": { background: "#009B4B" },
                "&.Mui-disabled": {
                  color: "white",
                  background: "#969696",
                  opacity: 1,
                },
              }}
              onClick={
                () => {
                  dispatch("submitBill")
                }
              }
              disabled={!(dialogBill?.isReadyUpdate)}
            >
              Cập nhật
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    // position: "absolute !important",
    bottom: 0,
    width: "100%",
    borderRadius: 0, // Loại bỏ bo góc nếu muốn
  },

  paperProps: {
    width: "100%",
    bottom: 0,
    margin: "0 !important",
    position: "absolute !important",
    borderTopLeftRadius: "16px !important",
    borderTopRightRadius: "16px !important",
  },

  content: {
    padding: "12px 12px 6px !important",
  },

  title: {
    width: "100%",
    borderBottom: "1px solid #EBF0ED",
    display: "flex",
    fontSize: "18px",
    fontWeight: "600",
    alignItems: "center",

    "& .text": { width: "-webkit-fill-available", textAlign: "center" },
  },

  form: {
    marginTop: "12px",
    fontSize: "14px",
  },

  box_button: {
    padding: "16px",
    boxShadow: "0 -4px 8px 0 rgba(0,0,0,0.1)",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    marginBottom: "12px",
  },

  //
}));
